import React from 'react'
import { useLocation } from 'react-router-dom'
import { useIntl } from 'react-intl'
import { HttpStatus, Redirect } from '@notino/react-toolkit/renderer/fragment/contexts/HttpContext'

// types
import { AvailableLanguages } from '../../types/types'

// pats
import Paths from '../paths'

const HomePageDeprecatedRoute = () => {
	const { locale } = useIntl() as { locale: AvailableLanguages }
	const { search } = useLocation()

	return (
		<HttpStatus status={301}>
			<Redirect to={`${Paths[locale]['/salons']}${search}`} />
		</HttpStatus>
	)
}

export default HomePageDeprecatedRoute
